export default {
      id: "locator-icon-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.svg#locator-icon",
      toString: function () {
        return this.url;
      }
    }